module.exports = __webpack_public_path__ + "static/media/meal.6b2476ee.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/lsc/meal.svg
// module id = 440
// module chunks = 0